customElements.define('card-isle-pickup-code', class CardIslePickupCode extends HTMLElement {
    connectedCallback() {
        setTimeout(() => this.replaceCartItemImageSource(), 10);
    }

    replaceCartItemImageSource() {
        const pickupCode = this.querySelector('template').innerHTML.trim();
        if (pickupCode) {
            const cartItemImage = this.closest('[data-cart-item]').querySelector('[data-cart-item-image]');
            if (cartItemImage) {
                const cardIsleCoverImage = document.createElement('img');
                cardIsleCoverImage.loading = 'eager';

                cardIsleCoverImage.addEventListener('load', () => {
                    cartItemImage.src = cardIsleCoverImage.src;
                    cartItemImage.width = cardIsleCoverImage.width;
                    cartItemImage.height = cardIsleCoverImage.height;
                });

                cardIsleCoverImage.src = 'https://www.cardisle.com/api/partner/get-cover-image/?pickup_code=' + pickupCode;

                this.remove();
            }
        }
    }
});

customElements.define('card-isle-launcher', class extends HTMLElement {
    connectedCallback() {
        this.prepareHiddenLauncherButton();
        this.addEventListener('click', event => this.openCardIsleEmbed(event));
    }

    openCardIsleEmbed(event) {
        const button = event.target;
        if (button.classList.contains('loading')) {
            return;
        }

        button.classList.add('loading');

        this.loadShopEmbed().then(() => {
            setTimeout(() => button.classList.remove('loading'), 7000);
            document.querySelector('.card-isle-button').click();
        });
    }

    loadShopEmbed() {
        return new Promise(resolve => {
            if (typeof initiate_card_isle_widget === 'function') {
                resolve();

                return;
            }

            const script = document.createElement('script');
            script.src = 'https://d9f7qlfbocnas.cloudfront.net/static/ecommerce/shop_embed.js';
            script.onload = () => {
                initiate_card_isle_widget();
                resolve();
            };
            document.body.appendChild(script);
        });
    }

    prepareHiddenLauncherButton() {
        const button = document.querySelector('.card-isle-button');
        if (!button) {
            document.body.insertAdjacentHTML(
                'beforeend',
                `<button type="button" class="card-isle-button" style="display: none"></button>`
            );
        }
    }
});

window.addEventListener('message', event => {
    const iframe = document.getElementById('card-isle-frame-container');
    if (!iframe || !iframe.classList.contains('show-container')) {
        return;
    }

    if (event.origin !== "https://www.cardisle.com" || typeof event.data !== 'object') {
        return;
    }

    if (event.data.status === 'success' && event.data.pickup_code) {
        const variantId = document.querySelector('[data-card-isle-variant-id]').dataset.cardIsleVariantId;

        const cartDrawer = document.getElementById('CartDrawer');

        let properties = {'Card Isle Print Code': event.data.pickup_code};

        if (event.data.card_text) {
            properties['Card Isle Message'] = BryanAnthonys.partiallySanitize(event.data.card_text);
        }

        const body = {
            items: [{
                id: variantId,
                properties: properties
            }],
            sections: cartDrawer.getSectionIdsToRender()
        };

        BryanAnthonys.cart.add(JSON.stringify(body), 'card-isle')
            .then(cart => cartDrawer.renderContents(cart))
            .catch(error => {
                console.error(error);
                alert('An unexpected error occurred. Please try refreshing the page. If the issue persists, please contact us.');
            });
    } else if (event.data.status === 'error' && event.data.pickup_code === '') {
        console.error(event.data);
    }
}, false);

window.addEventListener('DOMContentLoaded', () => {
    const cardIslePdpForm = document.querySelector('.product--type-personalized-greeting-cards product-form');
    if (!cardIslePdpForm) {
        return;
    }

    cardIslePdpForm.insertAdjacentHTML('beforebegin', `
        <card-isle-launcher class="no-js-hidden">
            <button type="button" class="button uppercase letter-spacing-1">Browse cards</button>
        </card-isle-launcher>
    `);
});